import { render, staticRenderFns } from "./society.vue?vue&type=template&id=0d040ec7&scoped=true"
import script from "./society.vue?vue&type=script&lang=js"
export * from "./society.vue?vue&type=script&lang=js"
import style0 from "./society.vue?vue&type=style&index=0&id=0d040ec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d040ec7",
  null
  
)

export default component.exports